export default __webpack_public_path__ + "static/assets/med_capsule_V_semi_01_b.ad350f13.png";